import BaseDialog from 'components/BaseDialog'
import React, { useCallback, useState } from 'react'
import { createModal } from 'react-modal-promise'
import { InjectedModalProps } from 'utils-next/modals'
import { ExtendableStyles } from 'utils-next/types'

import { Button, TextField, Typography } from '@mui/material'

import { ScoutingCampaign } from '../../../../../entities-next/scoutingCampaign'

const CONFIRMATION_TEXT = 'delete this space'

export type DeleteScoutingCampaignModalProps = ExtendableStyles &
  InjectedModalProps<boolean> & {
    scoutingCampaign: ScoutingCampaign
  }

export function DeleteScoutingCampaignModal({ isOpen, onResolve, scoutingCampaign }: DeleteScoutingCampaignModalProps) {
  const [confirmationInput, setConfirmationInput] = useState('')
  const handleConfirmationInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmationInput(e.target.value)
  }, [])

  const handleCancel = useCallback(() => {
    onResolve(false)
  }, [onResolve])
  const handleConfirm = useCallback(() => {
    onResolve(true)
  }, [onResolve])

  const isConfirmationDisabled = confirmationInput !== CONFIRMATION_TEXT
  return (
    <BaseDialog
      title="Are you sure you want to delete this corporate?"
      description={
        <div>
          <Typography>
            Deleting Space <strong>{scoutingCampaign.name}</strong> and all its data (deals, criteria...) is
            irreversible.
            <br />
            <br />
            To confirm, please type <em>{CONFIRMATION_TEXT}</em> in the input below.
          </Typography>
          <TextField margin="dense" value={confirmationInput} onChange={handleConfirmationInput} autoFocus />
        </div>
      }
      open={isOpen}
      onClose={handleCancel}
      actions={
        <Button onClick={handleConfirm} disabled={isConfirmationDisabled} variant="outlined">
          Delete Space
        </Button>
      }
    />
  )
}

export const showDeleteScoutingCampaignModal = createModal<DeleteScoutingCampaignModalProps>(
  DeleteScoutingCampaignModal
)
